export const dataRuleApi = {
  listConfig: '/clouddm/console/api/v1/datahandle/config/listconfig',
  configPackageBind: '/clouddm/console/api/v1/datahandle/config/configbind',
  availableSwitch: '/clouddm/console/api/v1/datahandle/config/switch',
  listTableDataHandleConfigs: '/clouddm/console/api/v1/datahandle/config/listtabledatahandleconfigs',
  updateRule: '/clouddm/console/api/v1/datahandle/config/updaterule',
  deleteRule: '/clouddm/console/api/v1/datahandle/config/deleterule'
};
